export var getPropsFromDecorators = function (decorators, payload, canAction) {
    if (decorators === void 0) { decorators = []; }
    return decorators.reduce(function (acc, curr) {
        var props = curr(payload || {}, { canAction: canAction }) || {};
        if (payload && payload.loading) {
            props.disabled = true;
        }
        return props;
    }, {});
};
//# sourceMappingURL=getPropsFromDecorators.js.map